import { render, staticRenderFns } from "./ActionView.vue?vue&type=template&id=6af7227e&lang=pug"
import script from "./ActionView.vue?vue&type=script&lang=js"
export * from "./ActionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports